export default "__VITE_ASSET__D2si5QfU__"